module.exports = __webpack_public_path__ + "img/app-store.749bf7c3.png";